export default __webpack_public_path__ + "static/media/img-14.546ca884.jpg";